<app-breadcrumb [master]="'Wyniki konkursów'" [parentName]="'Wyniki'" [name]="'Lista'"></app-breadcrumb>
<div fxLayout="column" fxLayoutGap="15px" class="list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="list-filters">

    <mat-form-field class="list-filter">
      <mat-label>Nazwa konkursu</mat-label>
      <input matInput placeholder="Nazwa konkursu" name="contains$competitionName" [(ngModel)]="initialFilters.contains$competitionName">
    </mat-form-field>

  </form>

  <div class="list-buttons"  fxLayout="row" fxLayoutAlign="end" >
    <div>
<!--      <button *ngIf="(userPermissions | async).registration.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).registration.read_report"-->
<!--              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>-->
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>


  <table mat-table [dataSource]="imports" >

    <ng-container matColumnDef="competitionName">
      <th mat-header-cell *matHeaderCellDef> Nazwa konkursu </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.competitionName">
          <a class="default-link" [routerLink]="['/wyniki-konkursow/szczegoly', element.uuid]">{{element.competitionName}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="importRow">
      <th mat-header-cell *matHeaderCellDef> Liczba zaimportowanych danych </th>
      <td mat-cell *matCellDef="let element">
        {{element.importedRows}}
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
